/* Valoure Sleep — behaviour ported 1:1 from the Lovable site */
(function () {
  'use strict';
  var LV = window.LV || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); };
  var colorByName = function (name) { return (LV.colors || []).find(function (c) { return c.name === name; }); };
  var colorById = function (id) { return (LV.colors || []).find(function (c) { return c.id === id; }); };

  /* ---------- Mobile menu ---------- */
  var menuOpen = false;
  function setMenu(open) {
    menuOpen = open;
    var menu = $('[data-lv-mobile-menu]');
    var btn = $('[data-lv-menu-toggle]');
    if (!menu || !btn) return;
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    btn.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
    $('[data-lv-menu-icon="open"]', btn).hidden = open;
    $('[data-lv-menu-icon="close"]', btn).hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lv-menu-toggle]')) { setMenu(!menuOpen); }
    else if (menuOpen && e.target.closest('[data-lv-mobile-menu] a')) { setMenu(false); }
  });

  /* ---------- Cart drawer ---------- */
  var cartEl = $('[data-lv-cart]');
  var cartState = null;

  function openCart() {
    if (!cartEl) return;
    setMenu(false);
    cartEl.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $('[data-lv-cart-overlay]', cartEl).setAttribute('data-open', 'true');
        $('[data-lv-cart-sheet]', cartEl).setAttribute('data-open', 'true');
        $('[data-lv-cart-sheet]', cartEl).focus({ preventScroll: true });
      });
    });
    refreshCart();
  }
  function closeCart() {
    if (!cartEl || cartEl.hidden) return;
    $('[data-lv-cart-overlay]', cartEl).setAttribute('data-open', 'false');
    $('[data-lv-cart-sheet]', cartEl).setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { cartEl.hidden = true; }, 300);
  }
  window.LVopenCart = openCart;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lv-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-lv-cart-close]') || e.target.closest('[data-lv-cart-overlay]')) {
      var link = e.target.closest('a[data-lv-cart-close]');
      closeCart();
      if (link && link.getAttribute('href') && location.pathname === new URL(link.href).pathname) e.preventDefault();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function lineColors(item) {
    var props = item.properties || {};
    if (props.Kleuren) return String(props.Kleuren).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var opt = (item.options_with_values || []).find(function (o) { return o.name === 'Kleur'; });
    return opt ? [opt.value] : [];
  }
  function lineName(item) {
    var opt = (item.options_with_values || []).find(function (o) { return o.name === 'Pakket'; });
    return opt ? opt.value : item.product_title;
  }

  function renderCart(cart) {
    cartState = cart;
    var count = cart.item_count || 0;
    $$('[data-lv-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    if (!cartEl) return;
    var list = $('[data-lv-cart-items]', cartEl);
    var empty = $('[data-lv-cart-empty]', cartEl);
    var foot = $('[data-lv-cart-footer]', cartEl);
    var tpl = document.getElementById('lv-cart-line');
    var chipTpl = document.getElementById('lv-cart-chip');
    list.innerHTML = '';
    if (!cart.items || cart.items.length === 0) {
      empty.hidden = false; list.hidden = true; foot.hidden = true; return;
    }
    empty.hidden = true; list.hidden = false; foot.hidden = false;
    var subtotal = 0, savings = 0;
    cart.items.forEach(function (item) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var line = item.final_line_price;
      var compareUnit = (LV.compare && LV.compare[item.variant_id]) || 0;
      var compare = compareUnit * item.quantity;
      subtotal += line;
      if (compare > line) savings += compare - line;
      $('[data-f="img"]', node).src = LV.cartImage || item.image;
      $('[data-f="name"]', node).textContent = lineName(item);
      var chips = $('[data-f="chips"]', node);
      lineColors(item).forEach(function (name) {
        var chip = chipTpl.content.firstElementChild.cloneNode(true);
        var c = colorByName(name);
        $('[data-f="dot"]', chip).style.backgroundColor = c ? c.hex : '#999999';
        $('[data-f="label"]', chip).textContent = name;
        chips.appendChild(chip);
      });
      $('[data-f="price"]', node).textContent = money(line);
      var cmp = $('[data-f="compare"]', node);
      if (compare > line) cmp.textContent = money(compare); else cmp.remove();
      $('[data-f="qty"]', node).textContent = item.quantity;
      $('[data-f="dec"]', node).addEventListener('click', function () { changeLine(item.key, item.quantity - 1); });
      $('[data-f="inc"]', node).addEventListener('click', function () { changeLine(item.key, item.quantity + 1); });
      $('[data-f="remove"]', node).addEventListener('click', function () { changeLine(item.key, 0); });
      list.appendChild(node);
    });
    $('[data-lv-cart-subtotal]', cartEl).textContent = money(subtotal);
    $('[data-lv-cart-total]', cartEl).textContent = money(cart.total_price);
    var sRow = $('[data-lv-cart-savings-row]', cartEl);
    sRow.hidden = savings <= 0;
    $('[data-lv-cart-savings]', cartEl).textContent = '− ' + money(savings);
  }

  function refreshCart() {
    return fetch((LV.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function changeLine(key, qty) {
    return fetch((LV.root || '/') + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(refreshCart);
  }
  function addToCart(items) {
    return fetch((LV.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Er ging iets mis.'); return j; });
    });
  }
  refreshCart();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------- Order counter (eerste 100) ---------- */
  function sbHeaders(extra) {
    var h = { apikey: LV.supabaseKey, Authorization: 'Bearer ' + LV.supabaseKey };
    for (var k in (extra || {})) h[k] = extra[k];
    return h;
  }
  function loadCounter() {
    if (LV.counterSource === 'manual' || !LV.supabaseUrl) return Promise.resolve(LV.counterFallback);
    return fetch(LV.supabaseUrl + '/rest/v1/order_counter?select=orders_placed,total_spots&limit=1', { headers: sbHeaders() })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (rows) {
        var row = rows && rows[0];
        if (!row) return LV.counterFallback;
        return { placed: row.orders_placed, total: row.total_spots == null ? 100 : row.total_spots };
      })
      .catch(function () { return LV.counterFallback; });
  }
  function applyCounter(c) {
    if (!c) return;
    var placed = c.placed || 0, total = c.total || 100;
    $$('[data-lv-counter]').forEach(function (el) {
      $('[data-lv-placed]', el).textContent = String(placed);
      $('[data-lv-left]', el).textContent = String(Math.max(total - placed, 0));
      el.hidden = false;
    });
    var prod = $('[data-lv-product]');
    if (prod) {
      $$('[data-lv-placed]', prod).forEach(function (n) { n.textContent = placed; });
      $$('[data-lv-total]', prod).forEach(function (n) { n.textContent = total; });
      var bar = $('[data-lv-progress]', prod);
      if (bar) bar.style.width = Math.min(100, Math.round(placed / Math.max(total, 1) * 100)) + '%';
    }
  }
  loadCounter().then(applyCounter);
  if ($('[data-lv-product]')) setInterval(function () { loadCounter().then(applyCounter); }, 30000);

  /* ---------- Nachten dit jaar ---------- */
  function updateNights() {
    var now = new Date();
    var end = new Date(now.getFullYear(), 11, 31);
    var n = Math.max(1, Math.ceil((end.getTime() - now.getTime()) / 864e5));
    $$('[data-lv-nights]').forEach(function (el) { el.textContent = n; });
  }
  updateNights();
  setInterval(updateNights, 1000);

  /* ---------- Reviews ---------- */
  $$('[data-lv-reviews]').forEach(function (root) {
    var toggle = $('[data-lv-review-toggle]', root);
    var form = $('[data-lv-review-form]', root);
    var thanks = $('[data-lv-review-thanks]', root);
    var errEl = $('[data-lv-review-error]', root);
    var list = $('[data-lv-review-list]', root);
    var cardTpl = $('template[data-lv-review-card]', root);
    var starTpl = $('template[data-lv-star]', root);
    var photoInput = $('[data-lv-photo]', root);
    var photoLabel = $('[data-lv-photo-label]', root);
    var preview = $('[data-lv-photo-preview]', root);
    var rating = 5, photo = null, busy = false;

    function setError(msg) { errEl.textContent = msg || ''; errEl.hidden = !msg; }
    function paintStars() {
      $$('[data-star]', root).forEach(function (b) {
        var svg = $('svg', b);
        var on = Number(b.getAttribute('data-star')) <= rating;
        svg.classList.toggle('fill-current', on);
        svg.classList.toggle('opacity-30', !on);
      });
    }
    function setPhoto(file) {
      setError('');
      if (!file) { photo = null; photoInput.value = ''; photoLabel.textContent = 'Kies of maak een foto'; preview.hidden = true; return; }
      if (!/^image\//.test(file.type)) { setError('Kies een afbeelding (jpg, png of webp)'); return; }
      if (file.size > 10 * 1024 * 1024) { setError('De foto mag maximaal 10 MB zijn'); return; }
      photo = file;
      photoLabel.textContent = file.name;
      $('img', preview).src = URL.createObjectURL(file);
      preview.hidden = false;
    }
    toggle.addEventListener('click', function () {
      var open = form.hidden;
      form.hidden = !open;
      toggle.textContent = open ? 'Sluiten' : 'Schrijf een review';
      thanks.hidden = true;
    });
    $$('[data-star]', root).forEach(function (b) {
      b.addEventListener('click', function () { rating = Number(b.getAttribute('data-star')); paintStars(); });
    });
    photoInput.addEventListener('change', function () { setPhoto(photoInput.files && photoInput.files[0] ? photoInput.files[0] : null); });
    $('[data-lv-photo-remove]', root).addEventListener('click', function () { setPhoto(null); });
    paintStars();

    function load() {
      if (!LV.supabaseUrl) return;
      fetch(LV.supabaseUrl + '/rest/v1/reviews?select=id,name,text,rating,created_at,image_path&order=created_at.desc&limit=9', { headers: sbHeaders() })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (rows) {
          rows = rows || [];
          var paths = rows.map(function (r) { return r.image_path; }).filter(Boolean);
          var signed = paths.length
            ? fetch(LV.supabaseUrl + '/storage/v1/object/sign/review-photos', {
                method: 'POST', headers: sbHeaders({ 'Content-Type': 'application/json' }),
                body: JSON.stringify({ expiresIn: 3600, paths: paths })
              }).then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; })
            : Promise.resolve([]);
          return signed.then(function (s) {
            var map = {};
            (s || []).forEach(function (x) { if (x.path && (x.signedURL || x.signedUrl)) map[x.path] = LV.supabaseUrl + '/storage/v1' + (x.signedURL || x.signedUrl); });
            render(rows, map);
          });
        }).catch(function () {});
    }
    function render(rows, map) {
      list.innerHTML = '';
      list.hidden = rows.length === 0;
      rows.forEach(function (r) {
        var card = cardTpl.content.firstElementChild.cloneNode(true);
        var stars = $('[data-f="stars"]', card);
        for (var i = 0; i < r.rating; i++) stars.appendChild(starTpl.content.firstElementChild.cloneNode(true));
        var img = $('[data-f="img"]', card);
        if (r.image_path && map[r.image_path]) { img.src = map[r.image_path]; img.alt = 'Foto bij de review van ' + r.name; img.hidden = false; } else { img.remove(); }
        $('[data-f="text"]', card).textContent = '"' + r.text + '"';
        $('[data-f="name"]', card).textContent = r.name;
        list.appendChild(card);
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      setError('');
      var name = form.elements.name.value.trim();
      var text = form.elements.text.value.trim();
      if (name.length < 1) return setError('Vul je naam in');
      if (name.length > 60) return setError('Naam is te lang');
      if (text.length < 5) return setError('Schrijf iets meer over je ervaring');
      if (text.length > 800) return setError('Review is te lang');
      var submit = $('button[type="submit"]', form);
      busy = true; submit.disabled = true; submit.textContent = 'Versturen…';
      var done = function () { busy = false; submit.disabled = false; submit.textContent = 'Review plaatsen'; };
      var upload = Promise.resolve(null);
      if (photo) {
        var ext = (photo.name.split('.').pop() || 'jpg').toLowerCase();
        var uuid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
        var path = uuid + '.' + ext;
        upload = fetch(LV.supabaseUrl + '/storage/v1/object/review-photos/' + path, {
          method: 'POST', headers: sbHeaders({ 'Content-Type': photo.type }), body: photo
        }).then(function (r) { if (!r.ok) throw 'photo'; return path; });
      }
      upload.then(function (imagePath) {
        return fetch(LV.supabaseUrl + '/rest/v1/reviews', {
          method: 'POST', headers: sbHeaders({ 'Content-Type': 'application/json', Prefer: 'return=minimal' }),
          body: JSON.stringify({ name: name, text: text, rating: rating, image_path: imagePath })
        }).then(function (r) { if (!r.ok) throw 'insert'; });
      }).then(function () {
        done();
        form.reset(); rating = 5; paintStars(); setPhoto(null);
        form.hidden = true; toggle.textContent = 'Schrijf een review'; thanks.hidden = false;
        load();
      }).catch(function (err) {
        done();
        setError(err === 'photo' ? 'De foto kon niet worden geüpload. Probeer een andere foto.' : 'Er ging iets mis. Probeer het opnieuw.');
      });
    });
    load();
  });

  /* ---------- Product page ---------- */
  var prod = $('[data-lv-product]');
  if (prod) {
    var data = { variants: [] };
    try { data = JSON.parse($('[data-lv-product-json]', prod).textContent); } catch (e) {}
    var cards = $$('[data-lv-bundle]', prod);
    var selected = String(prod.getAttribute('data-default-bundle') || '2');
    if (!cards.some(function (c) { return c.getAttribute('data-lv-bundle') === selected; })) selected = cards[0] ? cards[0].getAttribute('data-lv-bundle') : '1';
    var colors = {};
    cards.forEach(function (c) {
      var n = Number(c.getAttribute('data-count')) || 1;
      colors[c.getAttribute('data-lv-bundle')] = Array.apply(null, Array(n)).map(function () { return 'nacht'; });
    });
    var swatchWrap = $('[data-lv-main-swatches]', prod);
    var colorName = $('[data-lv-color-name]', prod);

    function card(id) { return cards.find(function (c) { return c.getAttribute('data-lv-bundle') === id; }); }

    function render() {
      var first = (colors[selected] || ['nacht'])[0];
      colorName.textContent = (colorById(first) || LV.colors[3]).name;
      swatchWrap.innerHTML = '';
      LV.colors.forEach(function (c) {
        var on = c.id === first;
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-pressed', String(on));
        b.title = c.name; b.setAttribute('aria-label', c.name);
        b.className = 'flex items-center justify-center rounded-full border p-1.5 transition-colors ' + (on ? 'border-primary bg-secondary' : 'border-border bg-surface hover:bg-secondary');
        b.innerHTML = '<span class="h-7 w-7 rounded-full border border-ink/15" style="background-color:' + c.hex + '"></span>';
        b.addEventListener('click', function () { colors[selected][0] = c.id; render(); });
        swatchWrap.appendChild(b);
      });

      cards.forEach(function (c) {
        var id = c.getAttribute('data-lv-bundle');
        var on = id === selected;
        c.classList.toggle('border-ink', on); c.classList.toggle('bg-secondary', on);
        c.classList.toggle('border-border', !on); c.classList.toggle('bg-surface', !on);
        var btn = $('[data-lv-bundle-btn]', c);
        btn.setAttribute('aria-pressed', String(on));
        var radio = $('[data-lv-radio]', c);
        radio.classList.toggle('border-ink', on); radio.classList.toggle('border-border', !on);
        $('span', radio).hidden = !on;
        var rows = $('[data-lv-mask-rows]', c);
        rows.innerHTML = '';
        rows.hidden = !on;
        if (!on) return;
        var list = colors[id];
        list.forEach(function (cid, i) {
          var row = document.createElement('div');
          row.className = 'flex items-center gap-3 rounded-xl border border-border bg-background px-3 py-2.5';
          row.innerHTML = '<span class="shrink-0 text-xs font-semibold text-foreground">#' + (i + 1) + '</span><div class="flex flex-wrap gap-2"></div>';
          var wrap = row.lastElementChild;
          LV.colors.forEach(function (col) {
            var sel = col.id === cid;
            var label = col.name + (list.length > 1 ? ' (masker ' + (i + 1) + ')' : '');
            var b = document.createElement('button');
            b.type = 'button'; b.title = label; b.setAttribute('aria-label', label); b.setAttribute('aria-pressed', String(sel));
            b.className = 'flex h-9 w-9 items-center justify-center rounded-lg border transition-all ' + (sel ? 'border-ink ring-2 ring-ink/15' : 'border-border hover:border-foreground/40');
            b.innerHTML = '<span class="h-6 w-6 rounded-md border border-ink/10" style="background-color:' + col.hex + '"></span>';
            b.addEventListener('click', function () { colors[id][i] = col.id; render(); });
            wrap.appendChild(b);
          });
          rows.appendChild(row);
        });
      });

      var sc = card(selected);
      var price = Number(sc.getAttribute('data-price')), compare = Number(sc.getAttribute('data-compare'));
      $$('[data-lv-add-price]').forEach(function (n) { n.textContent = money(price); });
      var sn = $('[data-lv-sticky-name]'); if (sn) sn.textContent = sc.getAttribute('data-name');
      var sp = $('[data-lv-sticky-price]'); if (sp) sp.textContent = money(price);
      var scmp = $('[data-lv-sticky-compare]'); if (scmp) scmp.textContent = compare > price ? money(compare) : '';
    }
    cards.forEach(function (c) {
      $('[data-lv-bundle-btn]', c).addEventListener('click', function () { selected = c.getAttribute('data-lv-bundle'); render(); });
    });
    render();

    $$('[data-lv-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sc = card(selected);
        var bundleName = sc.getAttribute('data-name');
        var list = colors[selected];
        var names = list.map(function (id) { return (colorById(id) || {}).name; });
        var variant = data.variants.find(function (v) { return v.bundle === bundleName && v.color === names[0]; })
          || data.variants.find(function (v) { return v.bundle === bundleName; });
        var err = $('[data-lv-add-error]', prod);
        if (err) err.hidden = true;
        if (!variant) return;
        var item = { id: variant.id, quantity: 1 };
        if (list.length > 1) item.properties = { Kleuren: names.join(', ') };
        btn.classList.add('lv-spinner');
        addToCart([item]).then(function () { btn.classList.remove('lv-spinner'); openCart(); })
          .catch(function (e) { btn.classList.remove('lv-spinner'); if (err) { err.textContent = e.message; err.hidden = false; } });
      });
    });

    /* gallery */
    var slider = $('[data-lv-slider]', prod);
    var thumbs = $$('[data-lv-thumbs] button', prod);
    var mainImg = $('[data-lv-main-image]', prod);
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('border-primary', on);
        t.classList.toggle('border-border', !on);
        t.classList.toggle('hover:border-foreground/30', !on);
      });
      var t = thumbs[i];
      if (mainImg && t) { mainImg.src = t.getAttribute('data-src'); mainImg.alt = t.getAttribute('data-alt'); }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        setActive(i);
        if (slider) slider.scrollTo({ left: i * (slider.clientWidth + 12), behavior: 'smooth' });
      });
    });
    if (slider) slider.addEventListener('scroll', function () {
      var w = slider.clientWidth + 12;
      var i = Math.min(thumbs.length - 1, Math.max(0, Math.round(slider.scrollLeft / w)));
      if (i !== current) setActive(i);
    }, { passive: true });

    /* sticky add-to-cart bar (mobile) */
    var sticky = $('[data-lv-sticky]');
    function onScroll() {
      if (!sticky) return;
      var show = prod.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('opacity-100', show);
      sticky.classList.toggle('opacity-0', !show);
      sticky.classList.toggle('pointer-events-none', !show);
      sticky.setAttribute('aria-hidden', String(!show));
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Accordion (single, collapsible) ---------- */
  $$('[data-lv-accordion]').forEach(function (acc) {
    var triggers = $$('.lv-acc-trigger', acc);
    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        var open = t.getAttribute('aria-expanded') !== 'true';
        triggers.forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          o.closest('.border-b').querySelector('.lv-acc-panel').hidden = true;
        });
        if (open) {
          t.setAttribute('aria-expanded', 'true');
          t.closest('.border-b').querySelector('.lv-acc-panel').hidden = false;
        }
      });
    });
  });

  /* ---------- Contact textarea auto-grow ---------- */
  $$('textarea[data-lv-autogrow]').forEach(function (ta) {
    var grow = function () { ta.style.height = 'auto'; ta.style.height = ta.scrollHeight + 'px'; };
    ta.addEventListener('input', grow);
  });

  /* ---------- Links to #bestel ---------- */
  if (location.hash === '#bestel' && $('#bestel')) setTimeout(function () { $('#bestel').scrollIntoView(); }, 50);
})();
